export default "__VITE_ASSET__f9176e9e__"